module.exports = __webpack_public_path__ + "ad4b77bd3f1c5e29c79cf8dae698f31a.jpg";